import type { ComponentPropsWithRef } from 'react';

type Props = ComponentPropsWithRef<'form'>;

export const Form = (props: Props) => {
  return <form noValidate {...props} />;
};
